/*@flow*/
/** @jsx jsx */
import type { Node } from 'react';
import { css, jsx, Global } from '@emotion/core';
import { createElement, useEffect, useState, Fragment } from 'react';
// Modal components
import Gateway from 'comps/Gateway';
import history from 'lib/history';
import isLoggedIn from 'lib/isLoggedIn';
import FreeModal from 'comps/FreeModal';
import delay from 'lib/delay';
import { isLargeScreen } from 'lib/getScreenWidth';
import { unset } from 'ops';

const modals = {
  gateway: Gateway,
};

export const GlobalModal = (): null | Node => {
  const { pathname } = history.getCurrentLocation();
  const [activeModalName, setActiveModalName] = useState('');

  useEffect(() => {
    const m = history.getKey('m');
    switch (pathname) {
      case '/sign_in':
        if (isLoggedIn()) {
          Turbolinks.visit('/', { action: 'replace' });
        } else {
          setActiveModalName('gateway');
        }
        break;
      case '/map':
        if (m in modals) {
          setActiveModalName(m);
        }
        break;
      default:
        break;
    }
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/map') {
      if (!history.getKey('retain')) {
        delay(100).then(() => {
          history.deleteKey('m');
          unset('$query.m');
        });
      }
    }
  }, [activeModalName]);

  if (!(activeModalName in modals)) return null;
  if (!activeModalName) return null;

  return (
    <Fragment>
      <Global
        styles={css(`
      .citi-modal {
        background-color: rgba(0, 0, 0, 0.5);
        .modal-content {
          border-radius: 0;
          overflow: hidden !important;
        }
        .modal-body {
          min-height: 65vh;
          background: white;
          color: #666;
          text-align: left;
        }

        .modal-header {
          padding-top: 0;
          .close {
            visibility: hidden;
          }
        }
      }
    `)}
      />
      <FreeModal
        id="gateway-modal"
        title="  "
        className="citi-modal"
        isOpen
        height={'80vh'}
        width={isLargeScreen() ? '50%' : '95vw'}
        requestClosePortal={() => {
          setActiveModalName('');
          if (pathname === '/sign_in') {
            Turbolinks.visit('/', { action: 'replace' });
          }
        }}
      >
        {createElement(modals[activeModalName])}
      </FreeModal>
    </Fragment>
  );
};

export default GlobalModal;
